import React, { useState, useEffect } from "react";
import { useAdminApi } from "../../AdminApiContext";

const TariffForm = ({ initial, onClose }) => {
  const { services, createTariff, updateTariff, deleteTariff } = useAdminApi();

  const blank = {
    name: "",
    daily_price: 0,
    month_price: 0,
    description: "",
    recomend:0,
    order:100,
    active: true,
    included_service_ids: [], // только ID для выбора
  };

  const [form, setForm] = useState(blank);

  useEffect(() => {
    if (initial) {
      const includedIds = (initial.included_services || []).map(s => s.service_id || s.id);
      setForm({
        name: initial.name || "",
        daily_price: initial.daily_price ?? 0,
        month_price: initial.month_price ?? 0,
        description: initial.description || "",
        recomend: initial.recomend ?? false,
        order:initial.order ?? 100,
        active: initial.active ?? true,
        included_service_ids: includedIds,
      });
    } else {
      setForm(blank);
    }
  }, [initial]);

  const change = (e) => {
    const { name, value, type } = e.target;
    const val = type === "number" ? parseFloat(value) : value;
    setForm(prev => ({
      ...prev,
      [name]: name === "active" ? value === "true" : val
    }));
  };

  const toggleService = (id) => {
    setForm(prev => ({
      ...prev,
      included_service_ids: prev.included_service_ids.includes(id)
        ? prev.included_service_ids.filter(sid => sid !== id)
        : [...prev.included_service_ids, id]
    }));
  };

  

  const save = async () => {
    const payload = {
      name: form.name,
      description: form.description,
      daily_price: parseFloat(form.daily_price),
      month_price: parseFloat(form.month_price),
      recomend: !!form.recomend,
      order:parseFloat(form.order),
      active: !!form.active,
      included_services: form.included_service_ids.map(id => ({
        service_id: id,
        value: services.find(s => s.id === id)?.value || 1,
        technical_name: services.find(s => s.id === id)?.technical_name || "",
      }))
    };

if (initial?.id) {
  payload.id = initial.id; // ⬅️ добавить это
  await updateTariff(initial.id, payload);
} else {
  await createTariff(payload);
}

    onClose();
  };




  return (
    <div style={{ border: "1px solid #ccc", padding: 16, marginTop: 12 }}>
      <h3>{initial ? "Редактировать тариф" : "Создать тариф"}</h3>

      <input
        name="name"
        placeholder="Название тарифа"
        value={form.name}
        onChange={change}
      />
      <input
        name="daily_price"
        type="number"
        placeholder="Цена в день"
        value={form.daily_price}
        onChange={change}
      />
      <input
        name="month_price"
        type="number"
        placeholder="Цена в месяц"
        value={form.month_price}
        onChange={change}
      />
      <textarea
        name="description"
        placeholder="Описание тарифа"
        value={form.description}
        onChange={change}
      />
        <input
        name="order"
        type="number"
        placeholder="номер в выдаче"
        value={form.order}
        onChange={change}
      />
      <label style={{ marginTop: 8 }}>
        ярлык "рекомендован":
        <select
          name="recomend"
          value={form.recomend}
          onChange={change}
          style={{ marginLeft: 8 }}
        >
          <option value={true}>Да</option>
          <option value={false}>Нет</option>
        </select>
      </label>
      <label style={{ marginTop: 8 }}>
        Активен:
        <select
          name="active"
          value={form.active}
          onChange={change}
          style={{ marginLeft: 8 }}
        >
          <option value={true}>Да</option>
          <option value={false}>Нет</option>
        </select>
      </label>

      <h4 style={{ marginTop: 12 }}>Включённые сервисы:</h4>
      {services.map(service => (
        <div key={service.id} style={{ marginBottom: 8 }}>
          <label>
            <input
              type="checkbox"
              checked={form.included_service_ids.includes(service.id)}
              onChange={() => toggleService(service.id)}
            />
            id:{service.id} {service.name} — {service.value} ({service.daily_price} ₽/день)
          </label>
          <div style={{ fontSize: "12px", color: "#666", marginLeft: 24 }}>
            {service.description}
          </div>
        </div>
      ))}

      <div style={{ marginTop: 12 }}>
        <button onClick={save}>
          {initial ? "Сохранить" : "Создать"}
        </button>
        <button onClick={onClose} style={{ marginLeft: 8 }}>
          Отмена
        </button>
      </div>
    </div>
  );
};

export default TariffForm;
